const companyInfo = {
  name: "Open Quant 株式会社",
  owner: "許 紅",
  create: "2024年7月29日",
  capital: "1,000万円",
  zip: "〒107-0061",
  address: "東京都港区北青山１丁目３番１号",
  addr2: "アールキューブ青山３階",
  email: "info@open-quant.com",
  website: "https://www.open-quant.com",
};
export default companyInfo;
